import { useEffect, useState } from 'react';
import { Layout, Spin } from 'antd';
import { callGetActiveLotto, callGetActiveLottoTickets } from '../../services/lottoService';
import { showNotificationTopEnd } from '../../util/utils';
import NotFound from '../NotFound/NotFound';
import LottoInfo from './LottoInfo/LottoInfo';
import Boletos from './Boletos/Boletos';

import botargaImage from "../../assets/images/botarga/Rifadito_Saludando.png";
import botargaNerviosa from "../../assets/images/botarga/Rifadito_Nervioso.png";
import botargaManosCadera from "../../assets/images/botarga/Rifadito_Manos_Cadera.png";

import './Lotto.css';

export default function Lotto() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [isActiveLotto, setIsActiveLotto] = useState(true);
    const [firstLoad, setFirstLoad] = useState(true);


    useEffect(() => {
        getLottoDetailAndTickets();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!firstLoad && data?.lottoId) {
            getActiveTickets(false);
        }
        // eslint-disable-next-line
    }, [refresh]);


    const getLottoDetailAndTickets = async () => {
        setLoading(true);

        const response = await callGetActiveLotto(false);
        if (response?.status === 200) {
            setData({ ...response?.data, tickets: [] });
            setIsActiveLotto(true);
            await getActiveTickets(true);
        } else {
            if (response?.status === 404) {
                setIsActiveLotto(false);
            } else {
                showNotificationTopEnd("error", "Error, por favor recarga la pagina");
            }
        }
        setLoading(false);
        setFirstLoad(false);
    };


    const getActiveTickets = async (isInitialLoad) => {
        if (!isInitialLoad) {
            setLoading(true);
        }

        const response = await callGetActiveLottoTickets();
        if (response?.status === 200) {
            setData(prev => {
                if (!prev) {
                    return prev;
                }
                return { ...prev, tickets: response?.data || [] };
            });
        } else if (response?.status !== 404) {
            showNotificationTopEnd("error", "Error, por favor recarga la pagina");
        }

        if (!isInitialLoad) {
            setLoading(false);
        }
    };


    return (
        <Layout className="boletos-container">
            {loading && firstLoad ? (
                <Spin spinning={loading} size="large">
                    <NotFound
                        title="Cargando..."
                        subtitle="Estamos cargando la información"
                        description="Espera unos momentos"
                        image={botargaManosCadera}
                    />
                </Spin>
            ) : (
                <>
                    {data == null ? (
                        isActiveLotto ? (
                            <NotFound
                                title="Oops! Parece que algo salió mal"
                                subtitle="Vuelve a intentarlo en otro momento"
                                description="Mantente informado a través de nuestras redes sociales"
                                image={botargaNerviosa}
                            />
                        ) : (
                            <NotFound
                                title="Nuestro último sorteo se ha cerrado"
                                subtitle="No te pierdas los próximos sorteos"
                                description="Lo anunciaremos próximamente en nuestras redes sociales"
                                image={botargaImage}
                            />
                        )
                    ) : (
                        <Spin spinning={loading} size="large">
                            <LottoInfo data={data} />
                            <Boletos data={data} refresh={refresh} setRefresh={setRefresh} />
                        </Spin>
                    )}
                </>
            )}
        </Layout>
    );
};